import React, { useState } from 'react';
import { HeartIcon, InstagramIcon, MessageCircleIcon, CheckCircleIcon, StarIcon, ArrowRightIcon, BookOpenIcon, SmartphoneIcon, UsersIcon, DollarSignIcon } from 'lucide-react';
export function SalesPage() {
  const [activeTab, setActiveTab] = useState<'letter' | 'social'>('letter');
  const [showPrivacy, setShowPrivacy] = useState(false);
  const [showTerms, setShowTerms] = useState(false);
  return <div className="min-h-screen bg-[#FDF6F0] text-[#3D2B1F] font-sans selection:bg-[#E8C4B0] selection:text-[#3D2B1F]" data-id="element-1">
      {/* Navigation / Header */}
      <nav className="sticky top-0 z-50 bg-[#FDF6F0]/90 backdrop-blur-sm border-b border-[#F0D9CC] py-4" data-id="element-2">
        <div className="max-w-6xl mx-auto px-4 flex justify-between items-center" data-id="element-3">
          <div className="font-serif text-xl font-bold tracking-wide text-[#C9956C]" data-id="element-4">
            MARIANA CALZADILLA
          </div>
          <button onClick={() => {
          setActiveTab('letter');
          setTimeout(() => {
            document.getElementById('precio')?.scrollIntoView({
              behavior: 'smooth'
            });
          }, 50);
        }} className="bg-[#C9956C] hover:bg-[#B07E58] text-white px-6 py-2 rounded-full text-sm font-bold transition-all shadow-md hover:shadow-lg transform hover:-translate-y-0.5" data-id="element-5">
            QUIERO MI LIBRO
          </button>
        </div>
      </nav>

      {/* Hero Section */}
      <header className="relative overflow-hidden py-16 md:py-24 lg:py-32" data-id="element-6">
        <div className="absolute top-0 left-0 w-full h-full opacity-10 pointer-events-none" data-id="element-7">
          <div className="absolute top-[-10%] right-[-5%] w-96 h-96 rounded-full bg-[#C9956C] blur-3xl" data-id="element-8"></div>
          <div className="absolute bottom-[-10%] left-[-5%] w-72 h-72 rounded-full bg-[#E8C4B0] blur-3xl" data-id="element-9"></div>
        </div>

        <div className="max-w-6xl mx-auto px-4 relative z-10" data-id="element-10">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center" data-id="element-11">
            {/* Text Content */}
            <div className="text-center lg:text-left order-2 lg:order-1" data-id="element-12">
              <div className="inline-block px-4 py-1.5 rounded-full bg-[#FFF8F5] border border-[#F0D9CC] text-[#C9956C] text-sm font-bold tracking-wider mb-6" data-id="element-13">
                PARA LA MUJER QUE QUIERE MÁS
              </div>
              <h1 className="text-5xl md:text-6xl lg:text-7xl font-serif font-bold leading-tight mb-4 text-[#3D2B1F]" data-id="element-14">
                FARMASI <br data-id="element-15" />
                <span className="text-[#C9956C] italic" data-id="element-16">DESDE CERO</span>
              </h1>
              <p className="text-xl md:text-2xl text-[#7A5C4F] font-light mb-8 max-w-lg mx-auto lg:mx-0" data-id="element-17">
                Manual de inicio + Plan de 30 días para construir tu
                independencia desde casa.
              </p>
              <p className="text-lg text-[#3D2B1F] mb-10 border-l-4 border-[#C9956C] pl-4 italic" data-id="element-18">
                "La guía que toda latina en USA necesitaba para empezar su
                propio negocio sin descuidar lo que más ama."
              </p>

              <div className="flex flex-col sm:flex-row gap-4 justify-center lg:justify-start" data-id="element-19">
                <button onClick={() => document.getElementById('precio')?.scrollIntoView({
                behavior: 'smooth'
              })} className="bg-[#C9956C] hover:bg-[#B07E58] text-white px-8 py-4 rounded-full text-lg font-bold transition-all shadow-lg hover:shadow-xl flex items-center justify-center gap-2" data-id="element-20">
                  QUIERO EMPEZAR HOY <ArrowRightIcon className="w-5 h-5" data-id="element-21" />
                </button>
                <div className="flex items-center justify-center gap-2 text-[#7A5C4F] text-sm px-4 py-2" data-id="element-22">
                  <div className="flex -space-x-2" data-id="element-23">
                    {[1, 2, 3].map(i => <div key={i} className="w-8 h-8 rounded-full bg-[#E8C4B0] border-2 border-white flex items-center justify-center text-xs font-bold text-white" data-id="element-24">
                        <HeartIcon className="w-4 h-4 fill-current" data-id="element-25" />
                      </div>)}
                  </div>
                  <span data-id="element-26">Únete a +500 mujeres</span>
                </div>
              </div>
            </div>

            {/* Image Content */}
            <div className="order-1 lg:order-2 flex justify-center relative" data-id="element-27">
              <div className="relative w-full max-w-md aspect-[3/4] rounded-2xl shadow-2xl overflow-hidden transform rotate-2 hover:rotate-0 transition-all duration-700" data-id="element-28">
                <img src="https://cdn.magicpatterns.com/uploads/nqkoQhd1vwqVCeJsVVLSJd/portada_del_ibook_farmasi_2.png" alt="Portada del libro Farmasi Desde Cero" className="w-full h-full object-cover" data-id="element-29" />
                <div className="absolute inset-0 ring-1 ring-inset ring-black/10 rounded-2xl" data-id="element-30"></div>
              </div>
              {/* Decorative elements */}
              <div className="absolute -bottom-6 -right-6 bg-white p-4 rounded-xl shadow-lg max-w-xs hidden md:block" data-id="element-31">
                <div className="flex items-center gap-3 mb-2" data-id="element-32">
                  <div className="bg-[#FFF8F5] p-2 rounded-full" data-id="element-33">
                    <StarIcon className="w-5 h-5 text-[#C9956C] fill-current" data-id="element-34" />
                  </div>
                  <div data-id="element-35">
                    <p className="font-bold text-sm" data-id="element-36">Plan de 30 Días</p>
                    <p className="text-xs text-gray-500" data-id="element-37">
                      Paso a paso incluido
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </header>

      {/* Content Tabs */}
      <section className="py-12 bg-white border-y border-[#F0D9CC]" data-id="element-38">
        <div className="max-w-6xl mx-auto px-4" data-id="element-39">
          <div className="flex justify-center mb-12" data-id="element-40">
            <div className="inline-flex bg-[#FFF8F5] p-1.5 rounded-full border border-[#F0D9CC]" data-id="element-41">
              <button onClick={() => setActiveTab('letter')} className={`px-6 py-2 rounded-full text-sm font-bold transition-all ${activeTab === 'letter' ? 'bg-[#C9956C] text-white shadow-md' : 'text-[#7A5C4F] hover:bg-[#E8C4B0]/20'}`} data-id="element-42">
                CARTA DE VENTAS
              </button>
              <button onClick={() => setActiveTab('social')} className={`px-6 py-2 rounded-full text-sm font-bold transition-all ${activeTab === 'social' ? 'bg-[#C9956C] text-white shadow-md' : 'text-[#7A5C4F] hover:bg-[#E8C4B0]/20'}`} data-id="element-43">
                ESTRATEGIA SOCIAL
              </button>
            </div>
          </div>

          {activeTab === 'letter' ? <div className="max-w-3xl mx-auto space-y-16 animate-in fade-in slide-in-from-bottom-4 duration-700" data-id="element-44">
              {/* PROBLEM (P) */}
              <div className="bg-[#FFF8F5] p-8 md:p-12 rounded-3xl border border-[#F0D9CC] relative" data-id="element-45">
                <div className="absolute -top-5 left-1/2 transform -translate-x-1/2 bg-white px-6 py-2 rounded-full border border-[#F0D9CC] shadow-sm" data-id="element-46">
                  <span className="font-serif text-[#C9956C] font-bold italic text-lg" data-id="element-47">
                    ¿Y si este fuera tu momento?
                  </span>
                </div>

                <h2 className="text-3xl md:text-4xl font-serif font-bold text-[#3D2B1F] mb-6 text-center" data-id="element-48">
                  Sé exactamente cómo te sientes.
                </h2>
                <p className="text-lg text-[#7A5C4F] mb-6 leading-relaxed" data-id="element-49">
                  Llevas años dando todo por tu familia. Eres la que cocina, la
                  que cuida, la que resuelve. Y en algún momento, en silencio,
                  te preguntaste:{' '}
                  <span className="font-bold text-[#3D2B1F]" data-id="element-50">
                    ¿Y yo? ¿Cuándo me toca a mí?
                  </span>
                </p>
                <p className="text-lg text-[#7A5C4F] leading-relaxed" data-id="element-51">
                  Quizás ya pensaste en ganar tu propio dinero, pero algo te
                  detiene. El miedo a la tecnología. El miedo a molestar a tus
                  amigas. El miedo a que te digan:{' '}
                  <span className="italic" data-id="element-52">
                    "¿A tu edad te vas a poner a vender cremitas?"
                  </span>
                  .
                </p>
              </div>

              {/* AGITATION (A) */}
              <div className="px-4 md:px-8" data-id="element-53">
                <h3 className="text-2xl font-serif font-bold text-[#3D2B1F] mb-6 border-l-4 border-[#C9956C] pl-4" data-id="element-54">
                  Pero lo que más duele no es el miedo... es la dependencia.
                </h3>
                <div className="space-y-4 text-lg text-[#7A5C4F]" data-id="element-55">
                  <p data-id="element-56">
                    Duele tener que pedir dinero para tus cosas personales.
                    Duele sentir que tus talentos se quedaron guardados en un
                    cajón hace 20 años. Duele ver cómo la vida pasa y sigues
                    siendo "la mamá de" o "la abuela de", olvidando que también
                    eres <span className="font-bold text-[#C9956C]" data-id="element-57">TÚ</span>.
                  </p>
                  <p data-id="element-58">
                    Y mientras tanto, ves en Instagram a otras mujeres de tu
                    edad viajando, arregladas, felices, generando ingresos desde
                    su celular... y piensas:{' '}
                    <span className="italic" data-id="element-59">"¿Por qué ellas sí y yo no?"</span>
                    .
                  </p>
                  <p className="font-bold text-[#3D2B1F]" data-id="element-60">
                    Te diré un secreto: Ellas no son más inteligentes que tú.
                    Solo tuvieron un plan que tú no tienes. Hasta hoy.
                  </p>
                </div>
              </div>

              {/* SOLUTION (S) */}
              <div className="bg-white p-8 md:p-12 rounded-3xl border-2 border-[#E8C4B0] shadow-xl text-center relative overflow-hidden" id="offer" data-id="element-61">
                <div className="absolute top-0 left-0 w-full h-2 bg-[#C9956C]" data-id="element-62"></div>
                <div className="mb-8" data-id="element-63">
                  <span className="text-sm font-bold tracking-widest text-[#C9956C] uppercase" data-id="element-64">
                    Presentamos
                  </span>
                  <h2 className="text-4xl md:text-5xl font-serif font-bold text-[#3D2B1F] mt-2 mb-4" data-id="element-65">
                    FARMASI DESDE CERO
                  </h2>
                  <p className="text-xl text-[#7A5C4F]" data-id="element-66">
                    No es solo un manual. Es tu boleto a la reinvención.
                  </p>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-2 gap-6 text-left mb-10" data-id="element-67">
                  <div className="flex items-start gap-3" data-id="element-68">
                    <CheckCircleIcon className="w-6 h-6 text-[#C9956C] flex-shrink-0 mt-1" data-id="element-69" />
                    <p className="text-[#5C4033]" data-id="element-70">
                      Aprende a vender sin perseguir a nadie (ni a tu familia).
                    </p>
                  </div>
                  <div className="flex items-start gap-3" data-id="element-71">
                    <CheckCircleIcon className="w-6 h-6 text-[#C9956C] flex-shrink-0 mt-1" data-id="element-72" />
                    <p className="text-[#5C4033]" data-id="element-73">
                      Domina la tecnología básica sin dolores de cabeza.
                    </p>
                  </div>
                  <div className="flex items-start gap-3" data-id="element-74">
                    <CheckCircleIcon className="w-6 h-6 text-[#C9956C] flex-shrink-0 mt-1" data-id="element-75" />
                    <p className="text-[#5C4033]" data-id="element-76">
                      Plan de 30 días exacto: qué hacer cada mañana.
                    </p>
                  </div>
                  <div className="flex items-start gap-3" data-id="element-77">
                    <CheckCircleIcon className="w-6 h-6 text-[#C9956C] flex-shrink-0 mt-1" data-id="element-78" />
                    <p className="text-[#5C4033]" data-id="element-79">
                      Guiones listos para copiar y pegar.
                    </p>
                  </div>
                </div>

                <div className="bg-[#FFF8F5] p-6 rounded-xl mb-8" id="precio" data-id="element-80">
                  <p className="text-sm font-bold tracking-widest text-[#A68B7B] uppercase line-through mb-1" data-id="element-81">
                    Precio regular: $27 USD
                  </p>
                  <p className="text-4xl font-serif font-bold text-[#C9956C] mb-1" data-id="element-82">
                    $6.39 USD
                  </p>
                  <div className="inline-block bg-[#C9956C] text-white text-xs font-bold px-3 py-1 rounded-full mb-2" data-id="element-83">
                    🎉 DESCUENTO DE LANZAMIENTO
                  </div>
                  <p className="text-sm text-[#7A5C4F]" data-id="element-84">
                    Pago único • Acceso inmediato
                  </p>
                </div>

                <a href="https://impulsocreaador.com/cart/44568354586735:1" target="_blank" rel="noopener noreferrer" onClick={() => {
              if (typeof window !== 'undefined' && (window as any).fbq) {
                ;
                (window as any).fbq('track', 'InitiateCheckout');
              }
            }} className="block w-full bg-[#C9956C] hover:bg-[#B07E58] text-white py-4 rounded-xl text-lg font-bold transition-all shadow-lg hover:shadow-xl mb-4 text-center" data-id="element-85">
                  QUIERO MI COPIA AHORA
                </a>
                <p className="text-xs text-[#A68B7B]" data-id="element-86">
                  Garantía de satisfacción de 7 días. Si no sientes que puedes
                  hacerlo, te devolvemos tu dinero.
                </p>
              </div>
            </div> : <div className="max-w-5xl mx-auto animate-in fade-in slide-in-from-bottom-4 duration-700" data-id="element-87">
              <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-12" data-id="element-88">
                {/* Instagram Hooks */}
                <div className="bg-white p-8 rounded-3xl border border-[#F0D9CC] shadow-sm" data-id="element-89">
                  <div className="flex items-center gap-3 mb-6" data-id="element-90">
                    <div className="bg-[#FFF8F5] p-3 rounded-full" data-id="element-91">
                      <InstagramIcon className="w-6 h-6 text-[#C9956C]" data-id="element-92" />
                    </div>
                    <h3 className="text-2xl font-serif font-bold text-[#3D2B1F]" data-id="element-93">
                      5 Ganchos para Reels
                    </h3>
                  </div>
                  <ul className="space-y-4" data-id="element-94">
                    {['Lo que nadie te dice de emprender a los 50...', 'Pensé que ya era tarde para mí, hasta que descubrí esto...', '3 mentiras que nos creemos las mujeres después de los 45.', 'No necesitas ser experta en tecnología para ganar en dólares.', 'Mi esposo me dijo que estaba loca, hoy le invité la cena.'].map((hook, i) => <li key={i} className="flex items-start gap-3 p-3 bg-[#FFF8F5] rounded-lg border border-[#F0D9CC]/50" data-id="element-95">
                        <span className="font-bold text-[#C9956C] font-serif text-lg" data-id="element-96">
                          {i + 1}.
                        </span>
                        <p className="text-[#5C4033] font-medium" data-id="element-97">"{hook}"</p>
                      </li>)}
                  </ul>
                </div>

                {/* Story Sequence */}
                <div className="bg-white p-8 rounded-3xl border border-[#F0D9CC] shadow-sm" data-id="element-98">
                  <div className="flex items-center gap-3 mb-6" data-id="element-99">
                    <div className="bg-[#FFF8F5] p-3 rounded-full" data-id="element-100">
                      <SmartphoneIcon className="w-6 h-6 text-[#C9956C]" data-id="element-101" />
                    </div>
                    <h3 className="text-2xl font-serif font-bold text-[#3D2B1F]" data-id="element-102">
                      Secuencia de Historias
                    </h3>
                  </div>
                  <div className="space-y-6" data-id="element-103">
                    <div className="relative pl-6 border-l-2 border-[#E8C4B0] space-y-6" data-id="element-104">
                      {[{
                    title: 'Historia 1 (Curiosidad)',
                    text: "Foto tuya sonriendo con café. Texto: 'Hace un año, mi mañana era solo limpiar. Hoy es esto...'"
                  }, {
                    title: 'Historia 2 (Problema)',
                    text: "Video hablando: 'Sentía que se me iba la vida cuidando a todos menos a mí.'"
                  }, {
                    title: 'Historia 3 (Solución)',
                    text: "Foto del libro en iPad. Texto: 'Este manual me enseñó que nunca es tarde.'"
                  }, {
                    title: 'Historia 4 (Llamado)',
                    text: "Fondo plano. Texto grande: 'Si quieres leer el primer capítulo gratis, responde LIBRO'."
                  }].map((story, i) => <div key={i} className="relative" data-id="element-105">
                          <div className="absolute -left-[29px] top-0 w-4 h-4 rounded-full bg-[#C9956C] border-2 border-white" data-id="element-106"></div>
                          <h4 className="font-bold text-[#3D2B1F] text-sm mb-1" data-id="element-107">
                            {story.title}
                          </h4>
                          <p className="text-[#7A5C4F] text-sm italic bg-[#FFF8F5] p-2 rounded" data-id="element-108">
                            {story.text}
                          </p>
                        </div>)}
                    </div>
                  </div>
                </div>
              </div>

              {/* DM Script & Bio */}
              <div className="grid grid-cols-1 lg:grid-cols-3 gap-8" data-id="element-109">
                <div className="lg:col-span-2 bg-[#3D2B1F] text-[#FDF6F0] p-8 rounded-3xl shadow-xl" data-id="element-110">
                  <div className="flex items-center gap-3 mb-6" data-id="element-111">
                    <MessageCircleIcon className="w-6 h-6 text-[#C9956C]" data-id="element-112" />
                    <h3 className="text-2xl font-serif font-bold" data-id="element-113">
                      Guión para DM (Cierre)
                    </h3>
                  </div>
                  <div className="space-y-4 font-light" data-id="element-114">
                    <p className="bg-white/10 p-4 rounded-xl rounded-tl-none border border-white/10" data-id="element-115">
                      "¡Hola hermosa! Qué alegría leerte. 🥰 Te entiendo
                      perfecto, yo también sentía ese miedo al principio. El
                      libro está diseñado justo para nosotras que no somos
                      'techies'. Te lleva de la mano paso a paso. ¿Te gustaría
                      ver el índice para que veas lo sencillo que es?"
                    </p>
                    <p className="text-sm text-[#A68B7B] italic text-center" data-id="element-116">
                      Esperar respuesta...
                    </p>
                    <p className="bg-white/10 p-4 rounded-xl rounded-tl-none border border-white/10" data-id="element-117">
                      "Genial. Aquí te dejo el enlace directo. Y ojo, incluye mi
                      soporte por WhatsApp por si te trabas en algo. No vas a
                      estar sola en esto. ✨ ¿Te paso el link?"
                    </p>
                  </div>
                </div>

                <div className="bg-white p-8 rounded-3xl border border-[#F0D9CC] shadow-sm flex flex-col justify-center" data-id="element-118">
                  <h3 className="text-xl font-serif font-bold text-[#3D2B1F] mb-4 text-center" data-id="element-119">
                    Link en Bio
                  </h3>
                  <div className="bg-gray-50 p-4 rounded-xl border border-gray-200 text-center" data-id="element-120">
                    <div className="w-16 h-16 bg-gray-200 rounded-full mx-auto mb-3 overflow-hidden" data-id="element-121">
                      <img src="https://cdn.magicpatterns.com/uploads/nqkoQhd1vwqVCeJsVVLSJd/portada_del_ibook_farmasi_2.png" className="w-full h-full object-cover opacity-50" data-id="element-122" />
                    </div>
                    <p className="font-bold text-sm mb-1" data-id="element-123">
                      Mariana | Negocios Reales
                    </p>
                    <p className="text-xs text-gray-600 mb-3" data-id="element-124">
                      Ayudo a mujeres +45 a emprender sin miedo a la tecnología.
                      👇 <br data-id="element-125" />
                      <span className="font-bold" data-id="element-126">
                        Descarga tu manual aquí:
                      </span>
                    </p>
                    <p className="text-blue-600 text-xs font-medium" data-id="element-127">
                      bit.ly/farmasi-desde-cero
                    </p>
                  </div>
                </div>
              </div>
            </div>}
        </div>
      </section>

      {/* Objection Handling Section */}
      <section className="py-16 bg-[#FFF8F5]" data-id="element-128">
        <div className="max-w-4xl mx-auto px-4" data-id="element-129">
          <h2 className="text-3xl font-serif font-bold text-[#3D2B1F] text-center mb-12" data-id="element-130">
            ¿Dudas? Hablemos claro.
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-131">
            {[{
            q: 'No sé usar redes sociales',
            a: '¡Mejor! Así no tienes vicios. El manual te enseña desde cero cómo usar lo básico para vender, sin bailes ridículos ni complicaciones.'
          }, {
            q: 'No tengo dinero ahora',
            a: 'Lo entiendo. Pero piénsalo: $27 es lo que gastamos en una pizza. La pizza dura 20 minutos, este conocimiento te puede dar de comer años.'
          }, {
            q: 'Ya estoy muy mayor',
            a: 'El Coronel Sanders empezó KFC a los 65. Tu edad no es un obstáculo, es tu mayor ventaja: tienes experiencia, paciencia y sabiduría que las de 20 no tienen.'
          }].map((item, i) => <div key={i} className="bg-white p-6 rounded-2xl shadow-sm border border-[#F0D9CC] hover:border-[#C9956C] transition-colors" data-id="element-132">
                <div className="flex items-center gap-2 mb-3" data-id="element-133">
                  <div className="w-2 h-2 rounded-full bg-[#C9956C]" data-id="element-134"></div>
                  <h4 className="font-bold text-[#3D2B1F] text-sm italic" data-id="element-135">
                    "{item.q}"
                  </h4>
                </div>
                <p className="text-[#7A5C4F] text-sm leading-relaxed" data-id="element-136">
                  {item.a}
                </p>
              </div>)}
          </div>
        </div>
      </section>

      {/* Privacy Policy Modal */}
      {showPrivacy && <div className="fixed inset-0 z-[100] flex items-center justify-center p-4 bg-black/50 backdrop-blur-sm" onClick={() => setShowPrivacy(false)} data-id="element-137">
          <div className="bg-white rounded-3xl shadow-2xl max-w-2xl w-full max-h-[80vh] overflow-hidden flex flex-col" onClick={e => e.stopPropagation()} data-id="element-138">
            <div className="flex items-center justify-between p-6 border-b border-[#F0D9CC]" data-id="element-139">
              <h2 className="text-2xl font-serif font-bold text-[#3D2B1F]" data-id="element-140">
                Política de Privacidad
              </h2>
              <button onClick={() => setShowPrivacy(false)} className="w-8 h-8 rounded-full bg-[#FFF8F5] hover:bg-[#F0D9CC] flex items-center justify-center text-[#7A5C4F] transition-colors text-lg font-bold" data-id="element-141">
                ✕
              </button>
            </div>
            <div className="overflow-y-auto p-6 space-y-4 text-sm text-[#7A5C4F] leading-relaxed" data-id="element-142">
              <p className="text-xs text-[#A68B7B]" data-id="element-143">
                Última actualización: 2025
              </p>
              <p data-id="element-144">
                Mariana Calzadilla ("nosotros", "nuestro") se compromete a
                proteger tu privacidad. Esta política explica cómo recopilamos y
                usamos tu información cuando adquieres nuestros productos
                digitales.
              </p>
              <h3 className="font-serif font-bold text-[#3D2B1F] text-base" data-id="element-145">
                1. Información que recopilamos
              </h3>
              <p data-id="element-146">
                Al realizar una compra, podemos recopilar tu nombre, dirección
                de correo electrónico e información de pago procesada de forma
                segura por terceros. No almacenamos datos de tarjetas de
                crédito.
              </p>
              <h3 className="font-serif font-bold text-[#3D2B1F] text-base" data-id="element-147">
                2. Uso de la información
              </h3>
              <p data-id="element-148">
                Usamos tu información únicamente para: entregar el producto
                digital adquirido, enviarte actualizaciones relacionadas con tu
                compra, y mejorar nuestros servicios.
              </p>
              <h3 className="font-serif font-bold text-[#3D2B1F] text-base" data-id="element-149">
                3. Compartir información
              </h3>
              <p data-id="element-150">
                No vendemos, alquilamos ni compartimos tu información personal
                con terceros, salvo lo necesario para procesar tu pago o cumplir
                con obligaciones legales.
              </p>
              <h3 className="font-serif font-bold text-[#3D2B1F] text-base" data-id="element-151">
                4. Seguridad
              </h3>
              <p data-id="element-152">
                Tomamos medidas razonables para proteger tu información. Sin
                embargo, ningún método de transmisión por Internet es 100%
                seguro.
              </p>
              <h3 className="font-serif font-bold text-[#3D2B1F] text-base" data-id="element-153">
                5. Tus derechos
              </h3>
              <p data-id="element-154">
                Tienes derecho a acceder, corregir o eliminar tu información
                personal. Puedes ejercer estos derechos escribiéndonos
                directamente por Instagram @mcmarianacalzadilla.
              </p>
              <h3 className="font-serif font-bold text-[#3D2B1F] text-base" data-id="element-155">
                6. Cambios a esta política
              </h3>
              <p data-id="element-156">
                Podemos actualizar esta política ocasionalmente. Te
                notificaremos de cambios significativos publicando la nueva
                versión en esta página.
              </p>
            </div>
          </div>
        </div>}

      {/* Terms of Service Modal */}
      {showTerms && <div className="fixed inset-0 z-[100] flex items-center justify-center p-4 bg-black/50 backdrop-blur-sm" onClick={() => setShowTerms(false)} data-id="element-157">
          <div className="bg-white rounded-3xl shadow-2xl max-w-2xl w-full max-h-[80vh] overflow-hidden flex flex-col" onClick={e => e.stopPropagation()} data-id="element-158">
            <div className="flex items-center justify-between p-6 border-b border-[#F0D9CC]" data-id="element-159">
              <h2 className="text-2xl font-serif font-bold text-[#3D2B1F]" data-id="element-160">
                Términos y Condiciones
              </h2>
              <button onClick={() => setShowTerms(false)} className="w-8 h-8 rounded-full bg-[#FFF8F5] hover:bg-[#F0D9CC] flex items-center justify-center text-[#7A5C4F] transition-colors text-lg font-bold" data-id="element-161">
                ✕
              </button>
            </div>
            <div className="overflow-y-auto p-6 space-y-4 text-sm text-[#7A5C4F] leading-relaxed" data-id="element-162">
              <p className="text-xs text-[#A68B7B]" data-id="element-163">
                Última actualización: 2025
              </p>
              <p data-id="element-164">
                Al adquirir "FARMASI DESDE CERO: Manual de inicio + Plan de 30
                días" aceptas los siguientes términos.
              </p>
              <h3 className="font-serif font-bold text-[#3D2B1F] text-base" data-id="element-165">
                1. Producto digital
              </h3>
              <p data-id="element-166">
                Este es un producto digital (eBook/PDF). Recibirás acceso
                inmediato tras confirmar tu pago. No se envían productos
                físicos.
              </p>
              <h3 className="font-serif font-bold text-[#3D2B1F] text-base" data-id="element-167">
                2. Uso personal
              </h3>
              <p data-id="element-168">
                Este material es para uso personal exclusivo. Queda prohibida su
                reproducción, distribución, reventa o compartición sin
                autorización escrita de la autora.
              </p>
              <h3 className="font-serif font-bold text-[#3D2B1F] text-base" data-id="element-169">
                3. Política de reembolso
              </h3>
              <p data-id="element-170">
                Ofrecemos garantía de satisfacción de 7 días. Si sientes que el
                libro no es para ti, escríbenos dentro de ese plazo y
                procesaremos tu reembolso sin preguntas.
              </p>
              <h3 className="font-serif font-bold text-[#3D2B1F] text-base" data-id="element-171">
                4. Resultados
              </h3>
              <p data-id="element-172">
                Los resultados de negocio varían según el esfuerzo, dedicación y
                condiciones individuales de cada persona. No garantizamos
                ingresos específicos. Este libro es una herramienta educativa.
              </p>
              <h3 className="font-serif font-bold text-[#3D2B1F] text-base" data-id="element-173">
                5. Propiedad intelectual
              </h3>
              <p data-id="element-174">
                Todo el contenido de este libro es propiedad de Mariana
                Calzadilla y está protegido por derechos de autor. Cualquier uso
                no autorizado será perseguido legalmente.
              </p>
              <h3 className="font-serif font-bold text-[#3D2B1F] text-base" data-id="element-175">
                6. Modificaciones
              </h3>
              <p data-id="element-176">
                Nos reservamos el derecho de actualizar estos términos en
                cualquier momento. El uso continuado del producto implica
                aceptación de los términos vigentes.
              </p>
            </div>
          </div>
        </div>}

      {/* Footer */}
      <footer className="bg-[#3D2B1F] text-[#A68B7B] py-12 border-t border-[#5C4033]" data-id="element-177">
        <div className="max-w-6xl mx-auto px-4 text-center" data-id="element-178">
          <p className="font-serif text-2xl text-[#E8C4B0] mb-4" data-id="element-179">
            Mariana Calzadilla
          </p>
          <div className="flex justify-center gap-6 mb-8" data-id="element-180">
            <InstagramIcon className="w-5 h-5 hover:text-white cursor-pointer transition-colors" data-id="element-181" />
            <MessageCircleIcon className="w-5 h-5 hover:text-white cursor-pointer transition-colors" data-id="element-182" />
          </div>
          <div className="flex justify-center gap-6 mb-6" data-id="element-183">
            <button onClick={() => setShowPrivacy(true)} className="text-[#E8C4B0]/70 hover:text-[#E8C4B0] text-xs underline underline-offset-2 transition-colors" data-id="element-184">
              Política de Privacidad
            </button>
            <span className="text-[#5C4033]" data-id="element-185">|</span>
            <button onClick={() => setShowTerms(true)} className="text-[#E8C4B0]/70 hover:text-[#E8C4B0] text-xs underline underline-offset-2 transition-colors" data-id="element-186">
              Términos y Condiciones
            </button>
          </div>
          <div className="max-w-2xl mx-auto text-xs text-[#7A5C4F] space-y-2" data-id="element-187">
            <p data-id="element-188">
              DISCLAIMER DE INGRESOS: Los resultados mencionados en este libro y
              en esta página son personales y de mis alumnas más dedicadas. No
              garantizamos que obtengas los mismos resultados. Tu éxito depende
              de tu esfuerzo, dedicación y constancia. Esto es un negocio real,
              no una fórmula mágica.
            </p>
            <p data-id="element-189">© 2025 Mariana Calzadilla. Todos los derechos reservados.</p>
          </div>
        </div>
      </footer>
    </div>;
}